import {copyStyle, findParent, getAllCustomProperties, nextFrame, setStyle} from 'app/core/helpers/dom';
import {Coordinates2D, PositionDirection} from 'app/core/interfaces/overlay.interface';

export class OverlayElementEditor {
    private coordinates: Coordinates2D;
    private direction: PositionDirection;
    positionSpecified = false;

    constructor(
        public id: string,
        private overlayElement: HTMLElement,
        private showCallback: (
            el: HTMLElement,
            position: {coordinates: Coordinates2D; direction: PositionDirection},
            fixed?: boolean,
            zIndex?: string
        ) => void,
        private removeCallback: (id: string) => void
    ) {}

    getElement() {
        return this.overlayElement;
    }

    copyCustomProperties(sourceElement: HTMLElement) {
        copyStyle(sourceElement, this.overlayElement, getAllCustomProperties());
    }

    setStyleProperties(element: HTMLElement, style: {[key: string]: string}) {
        setStyle(element, style);
    }

    tick(time?: number): Promise<void> {
        return nextFrame(time);
    }

    setPosition(coordinates: Coordinates2D, direction: PositionDirection) {
        this.coordinates = coordinates;
        this.direction = direction;
        this.positionSpecified = true;

        let element = this.getElement();
        element.classList.toggle('to-up', direction.vertical === 'up');
        element.classList.toggle('to-left', direction.horizontal === 'left');
    }

    showElement(fixed = false, zIndex?: string) {
        this.showCallback(
            this.overlayElement,
            this.positionSpecified
                ? {
                      coordinates: this.coordinates,
                      direction: this.direction,
                  }
                : {
                      coordinates: null,
                      direction: null,
                  },
            fixed,
            zIndex
        );
    }

    removeElement() {
        this.removeCallback(this.id);
    }

    copyStyles(sourceElement: HTMLElement, properties: Array<string>) {
        copyStyle(sourceElement, this.overlayElement, properties);
    }

    hasFixedParent(element: HTMLElement): HTMLElement {
        return findParent(element, (el: HTMLElement) => {
            let style = getComputedStyle(el);
            return style.getPropertyValue('position') === ('fixed' && 'sticky');
        });
    }
}
